<template>
  <div class="text-center">
    <v-dialog
      :model-value="modelValue"
      :width="width"
      :persistent="persistent"
      @update:model-value="$emit('update:modelValue', $event)"
    >
      <v-card>
        <v-card-title class="text-h5 bg-primary text-white">
          {{ title }}
        </v-card-title>
        <br>

        <v-card-text>
          <slot />
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-btn @click="$emit('cancel')">
            <v-icon>{{ cancelIcon }}</v-icon>
            {{ cancelText }}
          </v-btn>
          <v-spacer v-if="spread" />
          <v-btn
            color="primary"
            @click="$emit('confirm')"
          >
            <v-icon>{{ confirmIcon }}</v-icon>
            {{ confirmText }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ConfirmDialog",
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    width: {
      type: [String, Number],
      default: "500",
    },
    persistent: {
      type: Boolean,
      default: true,
    },
    spread: {
      type: Boolean,
      default: false,
    },
    confirmText: {
      type: String,
      default: "Yes",
    },
    confirmIcon: {
      type: String,
      default: "mdi-check",
    },
    cancelText: {
      type: String,
      default: "No",
    },
    cancelIcon: {
      type: String,
      default: "mdi-close",
    },
  },
  emits: ["update:modelValue", "confirm", "cancel"],
};
</script>

<style scoped></style>
